import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
	html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed,
	figure, figcaption, footer, header, hgroup,
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		font: inherit;
		vertical-align: baseline;
	}
	/* HTML5 display-role reset for older browsers */
	article, aside, details, figcaption, figure,
	footer, header, hgroup, menu, nav, section {
		display: block;
	}
	ol, ul {
		list-style: none;
	}
	blockquote, q {
		quotes: none;
	}
	blockquote:before, blockquote:after,
	q:before, q:after {
		content: '';
		content: none;
	}
	table {
		border-collapse: collapse;
		border-spacing: 0;
	}
	* {
		box-sizing: border-box;
	}
	body {
		font-family: 'Montserrat', sans-serif;
		color: #212121;
		background: #f2f2f2;
		line-height: 1.3;
		font-size: 100%;
	}
	img {
		display: block;
		width: 100%;
		height: auto;
	}

	a{
		color: inherit;
		text-decoration: none;
	}
	b{
		font-weight: bold;
	}
	button{
		font-family: inherit;
		font-size: 1rem;
		border: 2px solid transparent;
		background-color: transparent;
		cursor: pointer;
		outline-color: transparent;
		font-weight: 400;
	}

	input{
		&::placeholder{
		color: #e5e5e5;
		}
	}
`;

export default GlobalStyle;
